import React from 'react';

const IconLongArrow = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="prefix__arara"
        d="M1 9h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41L8.71.7C8.32.31 7.69.31 7.3.7c-.39.39-.39 1.02 0 1.41L12.17 7H1c-.55 0-1 .45-1 1s.45 1 1 1z"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path d="M0 0L24 0 24 24 0 24z" />
      <g transform="translate(4 4)">
        <mask
          id="prefix__brara"
          fill="#fff"
        >
          <use xlinkHref="#prefix__arara" />
        </mask>
        <g
          fill={color}
          mask="url(#prefix__brara)"
        >
          <path
            d="M0 0H24V24H0z"
            transform="translate(-4 -4)"
          />
        </g>
      </g>
    </g>
  </svg>

);

export default IconLongArrow;
